import { render, staticRenderFns } from "./AchievementDetails.vue?vue&type=template&id=2bc47522"
import script from "./AchievementDetails.vue?vue&type=script&lang=js"
export * from "./AchievementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports